<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="InnovationProductivityContainer" *ngIf="!loading; else loaderBlock">
  <!-- <div class="banner">
    </div> -->
  <nav *ngIf="!data.isModal" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a (click)="goHome()">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Innovation and productivity initiatives
      </li>
    </ol>
  </nav>
  <div class="dataFilterContainer">
    <div>
      <label> Engagement </label>
      <!-- <label motifLabel>Select label</label> -->
      <motif-form-field>
        <label motifLabel></label>
        <motif-select
          [(ngModel)]="multiSelectValues"
          aria-label="Aria Label"
          selectTitle="Select all"
          [showSelectAllButton]="true"
          [multiple]="true"
          (valueChange)="updateInitiatives('engagement', '')"
        >
          <motif-option
            *ngFor="let eng of engagementsList"
            [value]="eng.id"
            >{{ eng.name }}</motif-option
          >
        </motif-select>
      </motif-form-field>
    </div>
    <motif-form-field>
      <label motifLabel id="radio-button-group-label"></label>
      <motif-radio-button-group aria-label="Select an option">
        <motif-radio-button
          *ngFor="let tabs of initiativesTabs"
          (change)="updateInitiatives('status', tabs)"
          [value]="tabs"
          [checked]="tabs.name === activeInitiativeType.name"
          >{{ tabs.name }}</motif-radio-button
        >
      </motif-radio-button-group>
    </motif-form-field>
  </div>
  <div class="content">
    <label *ngIf="!data.isModal"  class="pageTitle">Innovation and productivity initiatives</label>
    <div class="listContainer" *ngIf="initiativesData.length" id="innovList">
      <ng-container *ngFor="let cs of initiativesData; track: cs">
        <div class="cs-card" >
          <div>
            <label class="cs-type" [ngStyle]="{'background': 'url('+ cs.imageUrl + ') 0% 0% / cover rgba(0, 0, 0, 0.6)'}">{{ cs.shortDescription }}</label>
            <label class="cs-title" [title]="cs.longDescription">
              {{ cs.longDescription }}
            </label>
          </div>
          <div class="tagList">
          <p class="cs-desc">{{cs.name}}</p>
          <p class="cs-desc">{{cs.engagementName}}</p>
        </div>
      </div>
      </ng-container>
    </div>
    <div class="noDataContaner" *ngIf="!initiativesData.length" >
      <span>No Documents</span>
    </div>
  </div>  
</div>
